<template>
<div class="bu">
  <div>
    <span class="bu__title">Bulk Update</span>
    <button class="selected-chip">
        {{ selectedIdsText }}
    </button>
  </div>
  <div>
    <div>
      <label class="bu__input">
        <span class="bu__label">Target Date</span>
      </label>
      <div class="bu__date-picker-wrapper">
        <input type="text" readonly class="bu__date-picker"
          @click="openPicker($event)"
          :value="targetDateDisplayValue"
            />
        <div class="bu__date-picker-select-wrapper">
          <v-date-picker
            :class="{}"
            ref='picker'
            :popover="pickerState"
            @input="selectNewDate($event)"
            v-model="selectedDate"
            :input-props="{
              class: 'hidden',
              readonly: true
            }">
          </v-date-picker>
        </div>
      </div>
    </div>
    <div>
      <label class="bu__input">
        <span class="bu__label">Fields</span>
      </label>
      <BulkUpdateFields @fieldData="updateFields($event)" />
    </div>
    <div>
      <label class="bu__input">
        <span class="bu__label">Attributes</span>
      </label>
      <BulkUpdateAttributes @attributeData="updateAttributes($event)" />
    </div>
    <div class="bu__controls">
      <button class="bu__button bu__button_submit"
              @click.prevent="apply()">
        Apply
      </button>
      <button class="bu__button bu__button_cancel"
              @click="close()">
        Cancel
      </button>
    </div>
  </div>
</div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'
import { mapState } from 'vuex'
import moment from 'moment'
import BulkUpdateAttributes from './BulkUpdateAttributes'
import BulkUpdateFields from './BulkUpdateFields'
import { get } from 'lodash'

export default {
  name: 'BulkUpdate',
  components: { BulkUpdateAttributes, BulkUpdateFields },
  mixins: [BaseModalMixins],
  props: {
    selectedIds: Array,
    urlAttributeIds: Array
  },
  data () {
    return {
      selectedDate: null,
      form: {
        targetDate: null,
        section: null,
        urlStatus: null,
        contentBriefStatus: null,
        writingStatus: null,
        pageType: null,
        optimized: null,
        assignedWriter: null,
        assignedStrategist: null,
        ids: this.selectedIds,
        attributes: []
      },
      pickerState: {
        visibility: 'focus'
      },
      isDatePickerOpened: false
    }
  },
  computed: {
    ...mapState('urlCensus', ['pageTypes', 'urlStatuses', 'sections', 'contentBriefStatuses', 'writingStatuses']),
    selectedIdsText () {
      let count = this.selectedIds.length
      let noneOrMultiple = count !== 1
      return `Selected ${count} Item${noneOrMultiple ? 's' : ''}`
    },
    targetDateDisplayValue () {
      let displayValue
      if (!this.form.targetDate) {
        displayValue = '- not set -'
      } else if (this.form.targetDate === -1) {
        displayValue = 'Remove Target Date'
      } else {
        displayValue = this.form.targetDate
      }
      return displayValue
    }
  },
  methods: {
    updateAttributes (attributes) {
      this.form.attributes = attributes
    },
    updateFields (fields) {
      fields.forEach(obj => {
        switch (obj.field) {
          case 'urlStatuses':
            this.form.urlStatus = obj.value
            break
          case 'sections':
            this.form.section = obj.value
            break
          case 'pageTypes':
            this.form.pageType = obj.value
            break
          case 'contentBriefStatuses':
            this.form.contentBriefStatus = obj.value
            break
          case 'writingStatuses':
            this.form.writingStatus = obj.value
            break
          case 'writers':
            this.form.assignedWriter = obj.value
            break
          case 'strategists':
            this.form.assignedStrategist = obj.value
            break
          case 'targetDate':
            this.form.targetDate = obj.value
            break
          case 'pageIsOptimized':
            this.form.optimized = obj.value
            break
        }
      })
    },
    selectNewDate (date) {
      if (date !== 'clear' && date !== -1) {
        if (moment(date).isValid()) {
          date = moment(date).format('YYYY-MM-DD')
        } else {
          date = null
        }
      }
      this.form.targetDate = date
      this.isDatePickerOpened = false
      this.pickerState.visibility = 'focus'
    },
    openPicker () {
      let handler = () => {
        this.pickerState.visibility = 'visible'
        this.isDatePickerOpened = true
        this.$nextTick(() => {
          this.addButton('remove', 'Remove', this.removeDateListener)
          this.addButton('clear', 'Clear', this.clearDateListener)
        })
      }
      handler = handler.bind(this)
      setTimeout(handler, 100)
    },
    close () {
      this.$emit('close')
    },
    apply () {
      this.$emit('apply', this.form)
    },
    /**
     * adds remove button to date picker popups
     */
    addButton (type, title, eventListener) {
      const containerArray = document.getElementsByClassName('vc-container')
      const container = containerArray.length > 0 ? containerArray[0] : null
      if (!container) {
        return
      }
      Array.from(containerArray).forEach(container => {
        const isButtonAttached = container.querySelector(`.rfx-date-button__${type}`)
        if (isButtonAttached) {
          return
        }
        if (container.parentElement.id === 'range') {
          return
        }
        container.style.height = '250px'
        const button = document.createElement('button')
        button.innerHTML = title
        button.classList = `rfx-date-button rfx-date-button__${type}`
        button.addEventListener('click', eventListener)
        container.appendChild(button)
      })
    },
    clearDateListener () {
      this.selectedDate = null
      this.form.targetDate = null
      this.isDatePickerOpened = false
      this.pickerState.visibility = 'focus'
    },
    removeDateListener () {
      this.selectedDate = -1
      this.form.targetDate = -1
      this.isDatePickerOpened = false
      this.pickerState.visibility = 'focus'
    }
  },
  created () {
    // we need it for handling date picker popup manually
    const clickHandler = function (event) {
      if (!this.isDatePickerOpened) {
        return
      }
      const classList = Array.from(get(event, 'target.classList', []))
      const insideDatePicker = classList.some(className => className.startsWith('vc-'))
      if (insideDatePicker) {
        return
      }
      this.pickerState.visibility = 'focus'
      this.isDatePickerOpened = false
    }
    const handler = clickHandler.bind(this)
    document.addEventListener('click', handler)
  }
}

</script>

<style scoped lang="scss">
  .selected-chip {
    border-radius: 15px;
    height: 30px;
    display: block;
    margin: 0 auto;
    background-color: $rfx-medium-march;
    color: #fff;
    outline: none;
    border: none;
    font-size: 13px;
    min-width: 120px;
    padding: 0 15px;
    margin-top: 15px;
    cursor: default;
  }
  .bu {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title {
      display: block;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
    }

    &__input {
        display: flex;
        flex-direction: column;
        position: relative;
        margin-top: 30px;

        &_invalid[type='text'] {
            border: 1px solid $rfx-red;
            border-radius: 4px;
        }
    }

    &__label {
        display: block;
        font-weight: 600;
        margin-bottom: 5px;
        color: $rfx-dark-march;
    }

    &__date-picker-wrapper {
      display: flex;
      flex-direction: column;
      position: relative;
      height: 40px;
      cursor: pointer;
    }

    &__date-picker-select-wrapper {
      position: absolute;
      bottom: 0;
    }

    &__date-picker {
      display: flex;
      border: 1px solid $rfx-light-steel;
      border-radius: 4px;
      outline: none;
      height: 40px;
      padding-left: 30px;
      font-size: 14px;
      position: absolute;
      box-sizing: border-box;
      width: 100%;
      cursor: pointer;
      z-index: 99;
    }

    &__radio_label {
        cursor: pointer;
    }

    &__controls {
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
    }

    &__button {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 900;
        text-transform: uppercase;
        margin-left: 30px;
        border: none;
        outline: none;
        cursor: pointer;

        &_submit {
            background-color: $rfx-medium-march;
            color: #fff;
        }

        &_cancel {
            color: $rfx-dark-march;
            background-color: #fff;
        }
    }

}

</style>
